var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_chart",
    "data-name": "vuesax/outline/chart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.482,
    height: 15.482,
    fill: "#707070",
    viewBox: "0 0 15.482 15.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.385.968H.484A.487.487,0,0,1,0,.484.487.487,0,0,1,.484,0h12.9a.487.487,0,0,1,.484.484A.487.487,0,0,1,13.385.968Z",
    transform: "translate(0.806 13.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.387,13.869H.484A.487.487,0,0,1,0,13.385V1.774A1.573,1.573,0,0,1,1.645,0h.581A1.573,1.573,0,0,1,3.87,1.774V13.385A.487.487,0,0,1,3.387,13.869ZM.968,12.9H2.9V1.774c0-.742-.348-.806-.677-.806H1.645c-.329,0-.677.065-.677.806V12.9Z",
    transform: "translate(5.806 0.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3.064,10H.484A.487.487,0,0,1,0,9.515V1.774C0,.664.568,0,1.516,0h.516C2.98,0,3.548.664,3.548,1.774V9.515A.487.487,0,0,1,3.064,10Zm-2.1-.968H2.58V1.774c0-.806-.355-.806-.548-.806H1.516c-.194,0-.548,0-.548.806V9.031Z",
    transform: "translate(1.451 4.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.064,6.773H.484A.487.487,0,0,1,0,6.29V1.774C0,.664.568,0,1.516,0h.516C2.98,0,3.548.664,3.548,1.774V6.29A.487.487,0,0,1,3.064,6.773Zm-2.1-.968H2.58V1.774c0-.806-.355-.806-.548-.806H1.516c-.194,0-.548,0-.548.806V5.806Z",
    transform: "translate(10.483 7.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H15.482V15.482H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.d1582740e9781ec537b8c5cba42da07b.svg";
export { ForwardRef as ReactComponent };